import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { Call } from '@gem/call/CallStore/Call';
import * as callModel from '@gem/call/Model/callModel';
import { CallAction, CallsServerErrorCode } from '@gem/call/Model/callModel.types';
import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';
import { popupsTasks } from '@gem/popups';

export class CallMembersService {
  call: Call;

  constructor(params: { call: Call }) {
    this.call = params.call;
  }

  private async onRemove(
    userId: string,
    deviceId: ProviderUid,
    channelId: string,
    alsoRemoveFromChat: boolean
  ): Promise<void> {
    if (alsoRemoveFromChat) {
      try {
        await callModel.removeCallMember({
          channelId,
          userId,
        });
      } catch (e) {
        if (e?.message === CallsServerErrorCode.HasNoPermissionsToPerformAction) {
          popupsTasks.showConfirm({
            text: t('calls_user_not_admin'),
            primaryText: t('common_ok'),
            secondaryText: null,
          });
        }
      }
    } else {
      try {
        await callModel.setActionCall({
          action: CallAction.ForceFinish,
          channelId,
          deviceId,
          userId,
        });
      } catch (e) {
        logger.get('Tasks').error('calls.removeMemberFromCall', e);
        console.error(e);
      }
    }
  }

  removeMemberFromCall(userId: string, deviceId: ProviderUid, channelId: string): void {
    const member = this.call.members.getMemberById(userId);

    if (!member) {
      return;
    }

    popupsTasks.showConfirm({
      text: t('calls_remove_user_alert', { 0: member.displayName }),
      primaryText: t('common_remove'),
      secondaryText: t('common_cancel'),
      onSuccess: async () => {
        await this.onRemove(userId, deviceId, channelId, false);
      },
    });
  }

  muteMember(userId: string, deviceId: ProviderUid, channelId: string): void {
    callModel.setActionCall({
      action: CallAction.ForceMute,
      channelId,
      userId,
      deviceId,
    });
  }
}
